import { render, staticRenderFns } from "./Review.vue?vue&type=template&id=34715576&scoped=true&lang=pug&"
import script from "./Review.vue?vue&type=script&lang=ts&"
export * from "./Review.vue?vue&type=script&lang=ts&"
import style0 from "./Review.vue?vue&type=style&index=0&id=34715576&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34715576",
  null
  
)

export default component.exports